<template>
  <div>
    <v-row class="pa-sm-2" align="center">
      <v-col cols="2" sm="1">
        <div :style="headerIconStyles">
          <v-icon :size="30" color="primary">{{ mdiCalendarRange }}</v-icon>
        </div>
      </v-col>
      <v-col cols="10" sm="11">
        <Header :text="formTitle" custom-class="mt-0 ml-4 ml-sm-8" />
      </v-col>
    </v-row>
    <v-row
      class="mt-4 mt-sm-8 pa-sm-4"
      align-content="stretch"
      align="stretch"
      justify="end"
    >
      <v-col class="d-flex pa-sm-0 pr-sm-4" cols="12" lg="7" sm="6">
        <FormAlert
          :error="formError"
          :field-errors="fieldErrors"
          :default-message="defaultMessage"
        />
      </v-col>
      <v-col class="pa-sm-0 suus__action-container" cols="12" lg="5" sm="6">
        <FormActions
          @save="emitSave"
          @cancel="emitCancel"
          :disable-save-button="disableSaveButton"
        />
      </v-col>
    </v-row>
    <v-row class="mt-2 mb-1">
      <v-col cols="12" class="d-flex justify-end">
        <TextBody :text="obligatoryFieldsText" />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import vuetify from "initializers/vuetify"
import { mdiCalendarRange } from "@mdi/js"
import Header from "components/UI/Header.vue"
import TextButton from "components/UI/TextButton.vue"
import Button from "components/UI/Button.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import ScrollTo from "components/UI/ScrollTo.vue"
import FormAlert, { FieldError } from "features/common/forms/FormAlert.vue"
import TextBody from "components/UI/TextBody.vue"
import FormActions from "features/common/forms/FormActions.vue"

export default defineComponent({
  name: "FormTopSection",
  components: {
    FormActions,
    TextBody,
    FormAlert,
    ScrollTo,
    Button,
    TextButton,
    Header,
  },
  props: {
    formTitle: { type: String, required: true },
    disableSaveButton: { type: Boolean, required: false, default: false },
    formError: { type: String, required: false },
    fieldErrors: { type: Array as () => FieldError[], required: false },
    defaultMessage: { type: String, required: true },
  },
  computed: {
    headerIconStyles() {
      return {
        border: `2px solid ${vuetify.framework.theme.themes.light.primary}`,
        borderRadius: `4px`,
        width: "50px",
        height: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }
    },
    obligatoryFieldsText(): string {
      return this.t$(".obligatory_fields")
    },
  },
  methods: {
    emitCancel() {
      this.$emit("cancel")
    },
    emitSave() {
      this.$emit("save")
    },
  },
  setup() {
    const { t$ } = useTranslate("common")
    return { mdiCalendarRange, t$ }
  },
})
</script>
